var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.17 18L12.17 15C12.11 15 12.06 15 12 15C9.63 15 7.71 15.73 6.52 16.34C6.2 16.5 6 16.84 6 17.22V18H15.17ZM10.13 7.3C10.41 6.54 11.14 6 12 6C13.1 6 14 6.9 14 8C14 8.86 13.46 9.59 12.7 9.87",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 17.1696L16.6301 13.7896C17.2701 14.0096 17.8601 14.2696 18.4001 14.5496C19.3701 15.0596 19.9801 16.0696 20.0001 17.1696ZM21.1901 21.1896L19.7801 22.5996L17.1701 19.9996H4.00014V17.2196C4.00014 16.0996 4.61014 15.0696 5.61014 14.5596C6.90014 13.8996 8.48014 13.3396 10.2801 13.1096L1.39014 4.21957L2.80014 2.80957L21.1901 21.1896ZM15.1701 17.9996L12.1701 14.9996C12.1101 14.9996 12.0601 14.9996 12.0001 14.9996C9.63014 14.9996 7.71014 15.7296 6.52014 16.3396C6.20014 16.4996 6.00014 16.8396 6.00014 17.2196V17.9996H15.1701ZM12.0001 5.99957C13.1001 5.99957 14.0001 6.89957 14.0001 7.99957C14.0001 8.85957 13.4601 9.58957 12.7001 9.86957L14.1801 11.3496C15.2801 10.6396 16.0001 9.39957 16.0001 7.99957C16.0001 5.78957 14.2101 3.99957 12.0001 3.99957C10.6001 3.99957 9.36014 4.71957 8.65014 5.81957L10.1301 7.29957C10.4101 6.53957 11.1401 5.99957 12.0001 5.99957Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateUser);
export default __webpack_public_path__ + "static/media/deactivate-user.8eb0b373ee28104c16ca10d6238a94ce.svg";
export { ForwardRef as ReactComponent };